import React from 'react';
export function PainPoints() {
  const painPoints = ['Te acuestas agotado pero tu mente no para de pensar', 'Te despiertas 2 o 3 veces por la noche sin razón aparente', 'A las 2pm sientes que no puedes más aunque tomaste café', 'Amaneces con tensión en la mandíbula o los hombros', 'Llevas meses durmiendo mal y ya lo normalizaste', 'Dormiste 8 horas pero sientes que no dormiste nada', 'Sientes el cuerpo cansado pero la mente sigue acelerada'];
  return <section className="w-full bg-navy-light py-16 md:py-24 px-4" data-id="element-245">
      <div className="max-w-5xl mx-auto" data-id="element-246">
        <p className="text-cyan text-sm uppercase tracking-widest text-center mb-4" data-id="element-247">
          ¿TE IDENTIFICAS?
        </p>

        <h2 className="text-2xl md:text-4xl font-bold text-white text-center mb-12" data-id="element-248">
          ¿Alguno de estos te suena familiar?
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-249">
          {painPoints.map((point, index) => <div key={index} className="bg-navy rounded-xl border-l-4 border-alert p-5" data-id="element-250">
              <p className="text-white text-base" data-id="element-251">❌ {point}</p>
            </div>)}
        </div>

        <p className="text-cyan text-center font-bold text-lg md:text-xl mt-12" data-id="element-252">
          Esto no es falta de disciplina.
          <br data-id="element-253" />
          Es fisiología. Y tiene solución.
        </p>
      </div>
    </section>;
}